// pages/Dashboard.jsx
import DashboardLayout from "../../components/dashboard/DashboardLayout";
import AdminCouponManager from "../../components/dashboard/AdminCouponManager";

export default function Dashboard() {
  return (
    <DashboardLayout>
      <AdminCouponManager />
    </DashboardLayout>
  );
}
